import styled from 'styled-components';
import { ReactComponent as RawInfoSVG } from '../../../../assets/icons/icon_info.svg';

export const IconInfo = styled(RawInfoSVG)``;
